"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = void 0;
var version = '8.1.1'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.

exports.version = version;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/version.js
// module id = JXmO
// module chunks = 23